// HVAC Designer / Technician
// Engineer
// Architect
// Researcher
export const USER_PROFFESSIONS = [
    {
        label: "Registered Energy Advisor",
        value: "registeredEnergyAdvisor",
    },
    {
        label: "HVAC Designer / Technician",
        value: "hvacDesignerTechnician",
    },
    {
        label: "Engineer",
        value: "engineer",
    },
    {
        label: "Architect",
        value: "architect",
    },
    {
        label: "Researcher",
        value: "researcher",
    },
    {
        label: "Student",
        value: "student",
    },
    {
        label: "Other",
        value: "other",
    },
];
